/**
 * BirdieBlues Gallery — color-aware image swapping.
 *
 * Key fix: when filtering by colour, prefer the FIRST thumb whose
 * data-color exactly matches, not just the first visible thumb.
 * This prevents shared "lifestyle" images (data-color="") from
 * being picked over the colour-specific image.
 */
(function () {
  'use strict';

  function initGallery(wrap) {
    if (wrap._bbReady) return;
    wrap._bbReady = true;

    // Scope everything to this gallery wrapper so the duplicate sticky
    // gallery controls its own image independently.
    var mainImg   = wrap.querySelector('.bb-gallery__main-img');
    var liItems   = Array.from(wrap.querySelectorAll('li.bb-gallery__thumb-item, li.bb-gallery__mobile-thumb-item'));
    var thumbBtns = Array.from(wrap.querySelectorAll('button.bb-gallery__thumb[data-src]'));

    // ── Show a specific image synchronously ──────────────────────────
    function showImage(btn) {
      if (!mainImg || !btn) return;
      var src = btn.dataset.src || '';
      if (!src) return;
      mainImg.src             = src;
      mainImg.srcset          = btn.dataset.srcset || '';
      mainImg.alt             = btn.dataset.alt    || '';
      mainImg.dataset.mediaId = btn.dataset.mediaId || '';

      thumbBtns.forEach(function (b) {
        var active = b.dataset.mediaId === btn.dataset.mediaId;
        b.classList.toggle('bb-gallery__thumb--active', active);
        b.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    // ── Show a variant's exact featured media ─────────────────────────
    // VariantSelects calls this for every option type. Color selections
    // additionally use filterColor() below to trim the visible thumbnail set.
    function showMedia(mediaId) {
      var target = thumbBtns.find(function (btn) {
        return btn.dataset.mediaId === String(mediaId);
      });
      if (!target) return false;

      showImage(target);
      try {
        target.closest('li').scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      } catch (ignore) {}
      return true;
    }

    // ── Filter thumbnails and swap to the correct image ──────────────
    function filterColor(color) {
      var exactBtn   = null;  // first thumb whose data-color === color
      var fallbackBtn = null; // first thumb with no color stamp (shared image)

      liItems.forEach(function (li) {
        var liColor = (li.dataset.color || '').trim();
        var show    = (liColor === '' || liColor === color);
        li.classList.toggle('bb-thumb-hidden', !show);
        if (show) {
          var btn = li.querySelector('button.bb-gallery__thumb[data-src]');
          if (btn) {
            // Prefer exact colour match over shared "lifestyle" images
            if (!exactBtn && liColor === color) exactBtn = btn;
            if (!fallbackBtn && liColor === '')  fallbackBtn = btn;
          }
        }
      });

      // Use exact match first; fall back to first shared image
      var target = exactBtn || fallbackBtn;
      if (target) {
        showImage(target);
        wrap.dataset.currentColor = color;
        try {
          target.closest('li').scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
        } catch (ignore) {}
      }
    }

    // Expose the scoped updater to the single document-level change handler.
    // Listening to the radio change (instead of a label click) also supports
    // keyboard selection and programmatic variant changes.
    wrap._bbFilterColor = filterColor;
    wrap._bbSetActiveMedia = showMedia;

    // ── Thumb button clicks ──────────────────────────────────────────
    thumbBtns.forEach(function (btn) {
      btn.addEventListener('click', function () { showImage(btn); });
    });

    // ── Initial filter on load ───────────────────────────────────────
    var initColor = (wrap.dataset.currentColor || '').trim();
    if (initColor) filterColor(initColor);
  }

  // ── Boot ──────────────────────────────────────────────────────────
  function initAll() {
    document.querySelectorAll('.bb-gallery[data-section]').forEach(initGallery);
  }

  function handleColorChange(event) {
    var radio = event.target;
    if (!radio || !radio.classList || !radio.classList.contains('bb-swatch-radio')) return;

    var picker = radio.closest('variant-radios, variant-selects');
    if (!picker || !picker.dataset.section) return;

    document.querySelectorAll('.bb-gallery[data-section]').forEach(function (wrap) {
      if (wrap.dataset.section !== picker.dataset.section) return;
      if (typeof wrap._bbFilterColor !== 'function') return;
      wrap._bbFilterColor((radio.value || '').trim());
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('change', handleColorChange);

  document.addEventListener('shopify:section:load', function () {
    initAll();
  });

})();
